import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/hooks/use-toast';
import { feedbackApi, FeedbackSubmissionInput, MyFeedbackItem } from '@/services/feedback';

// Sprint 38 + Feedback Functionality sprint — React Query hooks.

const KEY = ['feedback'];

export function useMyFeedback() {
  return useQuery<{ items: MyFeedbackItem[] }>({
    queryKey: [...KEY, 'mine'],
    queryFn: () => feedbackApi.myList(),
  });
}

export function useSubmitFeedback() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: FeedbackSubmissionInput) => feedbackApi.submit(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [...KEY, 'mine'] });
      toast({
        title: 'Feedback submitted',
        description: 'Thanks — your feedback was sent. AI analysis runs in the background.',
        variant: 'success',
      });
    },
    onError: (e: Error) =>
      toast({
        title: 'Could not submit feedback',
        description: e.message,
        variant: 'destructive',
      }),
  });
}

/** Capture metadata at submit time, including full origin in pageUrl. */
export function captureFeedbackMetadata(extra?: Record<string, unknown>) {
  const appVersion =
    (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_APP_VERSION) || 'dev';
  return {
    pageUrl:
      typeof window !== 'undefined'
        ? window.location.origin + window.location.pathname + window.location.search
        : undefined,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
    viewport:
      typeof window !== 'undefined' ? `${window.innerWidth}x${window.innerHeight}` : undefined,
    appVersion,
    metadata: extra && Object.keys(extra).length > 0 ? extra : undefined,
  };
}
